export default __webpack_public_path__ + "img/ec65e6adafc58efb7ad8628a4fc57254.png";